const singleProductSizes = document.querySelectorAll('.single-product__size');
singleProductSizes.forEach(link => link.addEventListener('click',()=>{
    if (link.classList.contains('is-active')) {
        link.classList.remove('is-active');
    } else {
        removeActiveClassesSizes();
        link.classList.add('is-active');
    }
}));
function removeActiveClassesSizes(){
    singleProductSizes.forEach(link => link.classList.remove('is-active'))
}

document.addEventListener('DOMContentLoaded', () => {
    const singleProductColors = document.querySelectorAll('.single-product__color');
    singleProductColors.forEach(link => {
        const input = link.querySelector('input[type="radio"]');
        if (input && input.checked) {
            link.classList.add('is-active');
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });

    // Handle .single-product__size
    const singleProductSizes = document.querySelectorAll('.single-product__size');
    singleProductSizes.forEach(link => {
        const input = link.querySelector('input[type="radio"]');
        if (input && input.checked) {
            link.classList.add('is-active');
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });
});

const singleProductColors = document.querySelectorAll('.single-product__color');
singleProductColors.forEach(link => link.addEventListener('click',()=>{
    if (link.classList.contains('is-active')) {
        link.classList.remove('is-active');
    } else {
        removeActiveClasses();
        link.classList.add('is-active');
    }
}));
function removeActiveClasses() {
  singleProductColors.forEach(link => link.classList.remove('is-active'));
}

setTimeout(() => {
    if (document.querySelectorAll('.splide__slide').length < 5) {
        document.querySelector('#thumbnail-carousel').classList.add('less-than-5')
    } else {
        document.querySelector('#thumbnail-carousel').classList.remove('less-than-5')
    }
}, "50");

function enlargeImagesOnHover() {
    const productImages = document.querySelectorAll('#main-carousel img');

    productImages.forEach(function (image) {
        image.addEventListener('mousemove', function (e) {
            const rect = image.getBoundingClientRect();
            const scaleX = (e.clientX - rect.left) / rect.width;
            const scaleY = (e.clientY - rect.top) / rect.height;

            image.style.transformOrigin = (scaleX * 100) + '% ' + (scaleY * 100) + '%';
            image.style.transform = 'scale(2.2)';
        });

        image.addEventListener('mouseleave', function () {
            image.style.transform = 'scale(1.0)';
        });
    });
}
enlargeImagesOnHover();

document.addEventListener('DOMContentLoaded', function() {
    if (window.location.href.indexOf('clearance') > -1) {
        document.querySelector('.single-product__wrap').classList.add('clearance-product');
    }
});